"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.genBizStoreParamsDealFn = exports.genBoolResultDealFn = exports.forceChangeParamsDealFn = exports.genDefaultParamsDealFn = exports.addDefaultCorpIdParamsDeal = exports.addWatchParamsDeal = void 0, exports.addWatchParamsDeal = function (e) {
  var a = Object.assign({}, e);
  return a.watch = !0, a;
}, exports.addDefaultCorpIdParamsDeal = function (e) {
  var a = Object.assign({}, e);
  return a.corpId = "corpId", a;
}, exports.genDefaultParamsDealFn = function (e) {
  var a = Object.assign({}, e);
  return function (e) {
    return Object.assign({}, a, e);
  };
}, exports.forceChangeParamsDealFn = function (e) {
  var a = Object.assign({}, e);
  return function (e) {
    return Object.assign(e, a);
  };
}, exports.genBoolResultDealFn = function (e) {
  return function (a) {
    var r = Object.assign({}, a);
    return e.forEach(function (e) {
      void 0 !== r[e] && (r[e] = !!r[e]);
    }), r;
  };
}, exports.genBizStoreParamsDealFn = function (e) {
  var a = Object.assign({}, e);
  return "string" != typeof a.params ? (a.params = JSON.stringify(a), a) : a;
};